// ...existing code...
<template>
  <v-card class="scout-card" elevation="3">
    <v-img
      :src="image || ''"
      class="scout-image"
      cover
    ></v-img>

    <v-card-text class="card-body">
      <div class="header">
        <div class="headline">{{ title }}</div>
        <div class="meta">{{ year }}</div>
      </div>

      <div>{{ text }}</div>
    </v-card-text>

  </v-card>
</template>

<script>
export default {
  name: 'ScoutActions',
  props: {
    title: { type: String, required: true },
    year: { type: [Number, String], default: '' },
    text: { type: String, default: '' },
    image: { type: String, default: '' },
  },
};
</script>

<style scoped>
.scout-card {
  max-width: 720px;
  margin: 16px auto;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(20, 24, 28, 0.08);
}

/* Bild oben, volle Breite */
.scout-image {
  object-fit: cover;
}

/* Inhalt */
.card-body {
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.header {
  display: flex;
  flex-direction: column;
}

.headline {
  font-weight: 700;
  font-size: 1.05rem;
  color: #121417;
}

.meta {
  color: rgba(0, 0, 0, 0.55);
  font-size: 0.9rem;
  margin-top: 4px;
}

/* Textauszug: max. Zeilen, sauberer Umbruch */
.excerpt {
  color: #333;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

/* Aktionen rechtsbündig */
.card-actions {
  padding: 8px 12px;
  background: transparent;
}

/* Responsive: engeres Layout auf kleinen Bildschirmen */
@media (max-width: 640px) {
  .scout-card {
    margin: 10px;
  }
  .scout-image {
    height: 180px !important;
  }
}
</style>
// ...existing code...